export default __webpack_public_path__ + "media/zurb/img/events/wired/pie-ranch/pie-ranch-photos-e7de48ee4f8307dc127803b5d323c905.png";